import VueRouter from 'vue-router';
/* eslint-disable */
function loadComponent(view) {
    return () =>
        import(`./components/${view}`);
}

let routes = [
    {
        path: '/',
        name: 'dashboard',
        component: loadComponent('Home/Dashboard'),
        meta: {
            forUsers: true,
            permission: 'read-dashboard'
        }
    },
    {
        path: '/announcements',
        name: 'announcements',
        component: loadComponent('Announcement/Index'),
        meta: {
            forUsers: true,
            permission: 'read-announcement'
        }
    },
    {
        path: '/localTrains',
        name: 'localTrains',
        component: loadComponent('Train/Index'),
        meta: {
            forUsers: true,
            permission: 'read-trains'
        }
    },
    {
        path: '/announcements/create',
        name: 'addAnnouncement',
        component: loadComponent('Announcement/Create'),
        meta: {
            forUsers: true,
            permission: 'read-announcement',
            breadcrumbs: [

                {
                    text: 'Service Alerts',
                    disabled: false,
                    href: '/announcements',
                },
                {
                    text: 'Create Service Alert',
                    disabled: true,
                    href: '/addAnnouncement'
                },
            ]
        }
    },
    {
        path: '/announcements/:id',
        name: 'announcementDetail',
        component: loadComponent('Announcement/Detail'),
        meta: {
            forUsers: true,
            permission: 'read-announcement',
            breadcrumbs: [

                {
                    text: 'Service Alerts',
                    disabled: false,
                    href: '/announcements',
                },

                {
                    text: 'Service Alert Details',
                    disabled: true,
                    href: '/announcements/:id',
                },
            ]
        }
    },
    {
        path: '/announcements/update/:id',
        name: 'updateAnnouncement',
        component: loadComponent('Announcement/Update'),
        meta: {
            forUsers: true,
            permission: 'update-announcement',
            breadcrumbs: [

                {
                    text: 'Service Alerts',
                    disabled: false,
                    href: '/announcements',
                },

                {
                    text: 'Service Alert Update',
                    disabled: true,
                    href: '/updateAnnouncement/:id',
                },
            ]
        }
    },


    {
        path: '/login',
        name: 'login',
        component: loadComponent('Login'),
        meta: {
            forGuests: true
        }
    },

    {
        path: '/notifications',
        name: 'Notifications',
        component: loadComponent('Notification/Index'),
        meta: {
            forUsers: true,
            permission: 'read-notification',
        }
    },
    {
        path: '/notifications/create',
        name: 'addNotification',
        component: loadComponent('Notification/Create'),
        meta: {
            forUsers: true,
            permission: 'read-notification',
            breadcrumbs: [
                {
                    text: 'Notifications',
                    disabled: false,
                    href: '/notifications',
                },

                {
                    text: 'Create Notification',
                    disabled: true,
                    href: '/addNotification',
                },
            ]
        }

    },
    {
        path: '/notifications/:id',
        name: 'notification',
        component: loadComponent('Notification/Detail'),
        meta: {
            forUsers: true,
            permission: 'read-notification',
            breadcrumbs: [
                {
                    text: 'Notifications',
                    disabled: false,
                    href: '/notifications',
                },
                {
                    text: 'Notification Details',
                    disabled: true,
                    href: '/addNotification',
                },
            ]
        }
    },
    {
        path: '/trainDevices',
        name: 'trainDevices',
        component: loadComponent('DeviceHealth/Index'),
        meta: {
            forUsers: true,
            permission: 'read-trains'
        }
    },
    {
        path: '/deviceHealthLogs',
        name: 'deviceHealthLogs',
        component: loadComponent('DeviceHealth/Index'),
        meta: {
            forUsers: true,
            permission: 'read-announcement'
        }
    },
    {
        path: '/train-tracking',
        name: 'trainTracking',
        component: loadComponent('TrainTracking/Index'),
        meta: {
            forUsers: true,
            permission: 'read-train-tracking'
        }
    },
    {
        path: '/train-tracking/:number',
        name: 'trainTrackingDetails',
        component: loadComponent('TrainTracking/Details'),
        meta: {
            forUsers: true,
            permission: 'read-train-tracking'
        }
    },
    {
        path: '/notifications/update/:notification_id',
        name: 'notificationUpdate',
        component: loadComponent('Notification/Edit'),
        meta: {
            forUsers: true,
            permission: 'read-notification',
            breadcrumbs: [
                {
                    text: 'Notifications',
                    disabled: false,
                    href: '/notifications',
                },
                {
                    text: 'Update Notification',
                    disabled: true,
                    href: '/notificationUpdate/:notification_id'
                },
            ]
        }
    },
    {
        path: '/trains',
        name: 'trains',
        component: loadComponent('Train/Index'),
    },
    {
        path: '/trainDetail/:id',
        name: 'trainDetail',
        component: loadComponent('Train/Detail'),
        meta: {
            forUsers: true,
            permission: 'read-trains',
            breadcrumbs: [
                {
                    text: 'Local Train',
                    disabled: false,
                    href: '/trains',
                },
                {
                    text: 'Train Details',
                    disabled: true,
                    href: '/trainDetail/:id'
                },
            ]
        }
    },
    {
        path: '/importMaster',
        name: 'importMaster',
        component: loadComponent('ImportMaster/Index'),
        meta: {
            forUsers: true,
            permission: 'import-masters'
        }
    },
    {
        path: '/importMaster/train-master',
        name: 'importTrainMaster',
        component: loadComponent('ImportMaster/TrainImport'),
        meta: {
            forUsers: true,
            permission: 'import-masters',
            breadcrumbs: [
                {
                    text: 'Import Master',
                    disabled: false,
                    href: '/importMaster'
                },
                {
                    text: 'Train Import Master',
                    disabled: true,
                    href: '/importMaster/train-master'
                },
            ]
        }
    },
    {
        path: '/importMaster/metro-master',
        name: 'importMetroMaster',
        component: loadComponent('ImportMaster/MetroImport'),
        meta: {
            forUsers: true,
            permission: 'import-masters',
            breadcrumbs: [
                {
                    text: 'Import Master',
                    disabled: false,
                    href: '/importMaster'
                },
                {
                    text: 'Metro Import Master',
                    disabled: true,
                    href: '/importMaster/metro-master'
                },
            ]
        }
    },
    {
        path: '/importMaster/mono-master',
        name: 'importMonoMaster',
        component: loadComponent('ImportMaster/MonoImport'),
        meta: {
            forUsers: true,
            permission: 'import-masters',
            breadcrumbs: [
                {
                    text: 'Import Master',
                    disabled: false,
                    href: '/importMaster'
                },
                {
                    text: 'Mono Import Master',
                    disabled: true,
                    href: '/importMaster/mono-master'
                },
            ]
        }
    },
    {
        path: '/stationAdsInventoryList',
        name: 'StationAdsInventoryList',
        component: loadComponent('StationAdsInventory/Index'),
        meta: {
            forUsers: true,
            permission: 'read-stationadsinventory'
        }
    },
    {
        path: '/addstationAdsInventory',
        name: 'addstationAdsInventory',
        component: loadComponent('StationAdsInventory/Create'),
        meta: {
            forUsers: true,
            permission: 'read-stationadsinventory',//'create-stationadsinventory',
            breadcrumbs: [
                {
                    text: 'Station Ads Inventory',
                    disabled: false,
                    href: '/stationAdsInventoryList'
                },
                {
                    text: 'Create Station Inventory',
                    disabled: true,
                    href: '/addstationAdsInventory'
                },

            ]
        }
    },
    {
        path: '/masters',
        name: 'select_master',
        component: loadComponent('Masters/create_module'),
        meta: {
            forUsers: true,
            permission: 'read-models'
        }
    },
    {
        path: '/Ecart-Booking-list',
        name: 'Ecart-Booking-list',
        component: loadComponent('Ecart/index'),
        meta: {
            forUsers: true,
            permission: 'read-models'//'read-Ecart-Booking-list'
        }
    },
    {
        path: '/create-ecart-booking',
        name: 'Create-Ecart-Booking',
        component: loadComponent('Ecart/create'),
        meta: {
            forUsers: true,
            permission: 'read-models',//'read-Create-Ecart-Booking',
            breadcrumbs: [
                {
                    text: 'Masters',
                    disabled: false,
                    href: '/masters',
                }, {
                    text: 'E-cart Bookings',
                    disabled: false,
                    href: '/Ecart-Booking-list',
                }, {
                    text: 'Create E-cart Booking',
                    disabled: true,
                    href: '/notificationUpdate/:notification_id',
                },
            ]
        }
    },
    {
        path: '/contact-list',
        name: 'Contact-List',
        component: loadComponent('Contact/index'),
        meta: {
            forUsers: true,
            permission: 'read-models',//'read-Contact-List',
            breadcrumbs: [
                {
                    text: 'Masters',
                    disabled: false,
                    href: '/masters',
                },

                {
                    text: 'Contact List',
                    disabled: true,
                    href: '/contact-list',
                },
            ]
        }
    },
    {
        path: '/create-contact',
        name: 'Create-Contact',
        component: loadComponent('Contact/create'),
        meta: {
            forUsers: true,
            permission: 'read-models',//'read-Create-Contact',
            breadcrumbs: [
                {
                    text: 'Masters',
                    disabled: false,
                    href: '/masters',
                }, {
                    text: 'Contacts',
                    disabled: false,
                    href: '/contact-list',
                }, {
                    text: 'Create Contact',
                    disabled: true,
                    href: '#',
                }
            ]
        }
    },
    {
        path: '/railway-penalty-list',
        name: 'railway-penalty-list',
        component: loadComponent('RailwayPenalty/index'),
        meta: {
            forUsers: true,
            permission: 'read-models',//'read-railway-penalty-list',
            breadcrumbs: [
                {
                    text: 'Masters',
                    disabled: false,
                    href: '/masters',
                }, {
                    text: 'Railway Penalty List',
                    disabled: true,
                    href: '/railway-penalty-list',
                },

            ]

        }
    },
    {
        path: '/create-railway-penalty',
        name: 'create-railway-penalty',
        component: loadComponent('RailwayPenalty/create'),
        meta: {
            forUsers: true,
            permission: 'read-models',//'read-create-railway-penalty',
            breadcrumbs: [
                {
                    text: 'Masters',
                    disabled: false,
                    href: '/masters',
                }, {
                    text: 'Railway Penalty',
                    disabled: false,
                    href: '/railway-penalty-list',
                }, {
                    text: 'Create Railway Penalty',
                    disabled: true,
                    href: '#',
                },]
        }
    },
    {
        path: '/station-amenities-list',
        name: 'station-amenities-list',
        component: loadComponent('StationAmenity/index'),
        meta: {
            forUsers: true,
            permission: 'read-models',//'station-amenities-list',
            breadcrumbs: [
                {
                    text: 'Masters',
                    disabled: false,
                    href: '/masters',
                },
                {
                    text: 'Station Amenity',
                    disabled: false,
                    href: '/station-amenities-list',
                },
            ]
        }
    },
    {
        path: '/create-station-amenity',
        name: 'create-station-amenity',
        component: loadComponent('StationAmenity/create'),
        meta: {
            forUsers: true,
            permission: 'read-models',//'read-create-station-amenity',
            breadcrumbs: [
                {
                    text: 'Masters',
                    disabled: false,
                    href: '/masters',
                },
                {
                    text: 'Station Amenity',
                    disabled: false,
                    href: '/station-amenities-list',
                }, {
                    text: 'Create Station Amenity',
                    disabled: true,
                    href: '#',
                },]
        }
    },

    {
        path: '/feedbackList',
        name: 'feedbackList',
        component: loadComponent('Feedback/index'),
        meta: {
            forUsers: true,
            permission: 'read-feedbacks'
        }
    },
    {
        path: '/feedback/:id',
        name: 'feedback',
        component: loadComponent('Feedback/Detail'),
        meta: {
            forUsers: true,
            permission: 'read-feedbacks',
            breadcrumbs: [
                {
                    text: 'Feedback',
                    disabled: false,
                    href: '/feedbackList',
                },
                {
                    text: 'Feedback Details',
                    disabled: true,

                },
            ]

        }
    },
    {
        path: '/featureSuggestionList',
        name: 'featureSuggestionList',
        component: loadComponent('Suggestion/Index'),
        meta: {
            forUsers: true,
            permission: 'read-suggestions'
        }
    },
    {
        path: '/suggestion/:id',
        name: 'suggestionDetails',
        component: loadComponent('Suggestion/Detail'),
        meta: {
            forUsers: true,
            permission: 'read-suggestions',
            breadcrumbs: [

                {
                    text: 'Feature Suggestion',
                    disabled: false,
                    href: '/featureSuggestionList',
                },

                {
                    text: 'Suggestion Details',
                    disabled: true,

                },
            ]

        }
    },
    {
        path: '/news',
        name: 'newsList',
        component: loadComponent('CommuteNews/Index'),
        meta: {
            forUsers: true,
            permission: 'read-news'
        }
    },
    {
        path: '/news/create',
        name: 'newsCreate',
        component: loadComponent('CommuteNews/Create'),
        meta: {
            forUsers: true,
            permission: 'read-news',
            breadcrumbs: [
                {
                    text: 'Commute News',
                    disabled: false,
                    href: '/news',
                },
                {
                    text: 'Create News',
                    disabled: true,
                    href: '/news'
                },
            ]
        }
    },


    {
        path: '/news/:id',
        name: 'newsDetail',
        component: loadComponent('CommuteNews/Detail'),
        meta: {
            forUsers: true,
            permission: 'read-news',
            breadcrumbs: [

                {
                    text: 'Commute News',
                    disabled: false,
                    href: '/news',
                },

                {
                    text: 'Commute News Details',
                    disabled: true,
                    href: '/news/:id',
                },
            ]
        }
    },

    {
        path: '/news/update/:id',
        name: 'newsUpdate',
        component: loadComponent('CommuteNews/Update'),
        meta: {
            forUsers: true,
            permission: 'read-news',
            breadcrumbs: [
                {
                    text: 'Commute News',
                    disabled: false,
                    href: '/news',
                },

                {
                    text: 'Commute News Update',
                    disabled: true,
                    href: '/newsUpdate/:id',
                },
            ]
        }
    },
    {
        path: '/referral-list',
        name: 'yatriReferralList',
        component: loadComponent('ReferralUsers/Index'),
        meta: {
            forUsers: true,
            permission: 'read-referral',
        }
    },
    {
        path: '/yartikar-moments',
        name: 'yatrikarMoments',
        component: loadComponent('Yatrikar/Index'),
        meta: {
            forUsers: true,
            permission: 'read-yatrikar'
        }
    },
    {
        path: '/yartikar-moment/:id',
        name: 'yatrikarMomentDetails',
        component: loadComponent('Yatrikar/Details'),
        meta: {
            forUsers: true,
            permission: 'read-referral'
        }
    },

    {
        path: '/waAnnouncements/create',
        name: 'addAnnouncement1',
        component: loadComponent('WA Announcement/Create'),
        meta: {
            forUsers: true,
            permission: 'create-announcement',
        }
    },

    {
        path: '/trip-announcements',
        name: 'trip-announcements',
        component: loadComponent('TripAnnouncement/Index'),
        meta: {
            forUsers: true,
            permission: 'read-trip-announcement'
        }
    },
    {
        path: '/trip-updates/create',
        name: 'trip-updates-create',
        component: loadComponent('TripAnnouncement/Create'),
        meta: {
            forUsers: true,
            permission: 'create-trip-announcement',
            breadcrumbs: [
                {
                    text: 'Train Update',
                    disabled: false,
                    href: '/trip-announcements',
                },
                {
                    text: 'Create Train Update',
                    disabled: true,
                }
            ]
        }
    },
    {
        path: '/trip-announcements/update/:id',
        name: 'train-update-edit',
        component: loadComponent('TripAnnouncement/Edit'),
        meta: {
            forUsers: true,
            permission: 'update-trip-announcement',
            breadcrumbs: [
                {
                    text: 'Train Update',
                    disabled: false,
                    href: '/trip-announcements'
                },
                {
                    text: 'Train Update Details',
                    disabled: true,
                },
            ]
        },
    },
    {
        path: '/travelHacks',
        name: "travel-hacks",
        component: loadComponent('TravelHack/Index'),
        meta: {
            forUsers: true,
            permission: "read-travel-hack"
        }
    },
    //rake tracking
    {
        path: '/rake-tracking',
        name: "rake-tracking",
        component: loadComponent('RakeTracking/Index'),
        meta: {
            forUsers: true,
            permission: "read-rake-tracking"
        }
    },
    {
        path: '/rake-tracking/:id',
        name: "rake-tracking-details",
        component: loadComponent('RakeTracking/Detail'),
        meta: {
            forUsers: true,
            permission: "read-rake-tracking",
            breadcrumbs: [
                {
                    text: 'Rake tracking',
                    disabled: false,
                    href: '/rake-tracking'
                },
                {
                    text: 'Rake tracking Details',
                    disabled: true
                }
            ]
        }
    },

    //user incident reports
    {
        path: '/incident-report',
        name: "incident-report",
        component: loadComponent('UserIncidentsReport/Index'),
        meta: {
            forUsers: true,
            permission: "read-incident-report"
        }
    },
    {
        path: '/restricted-users',
        name: "restricted-users",
        component: loadComponent('UserIncidentsReport/BlockedUserList'),
        meta: {
            forUsers: true,
            permission: "read-incident-report",
            breadcrumbs: [
                {
                    text: 'User Incidents',
                    disabled: false,
                    href: '/incident-report'
                },
                {
                    text: 'Restricted Users',
                    disabled: true
                }
            ]
        }
    },
    {
        path: '/restricted-users/:id',
        name: "restrictedUserIncidents",
        component: loadComponent('UserIncidentsReport/BlockUserIncidents'),
        meta: {
            forUsers: true,
            permission: "read-incident-report",
            breadcrumbs: [
                {
                    text: 'User Incidents',
                    disabled: false,
                    href: '/incident-report'
                },
                {
                    text: 'Restricted Users',
                    disabled: false,
                    href: '/restricted-users'
                },
                {
                    text: 'Restricted User incidents',
                    disabled: true
                }
            ]
        }
    },
    {
        path: '/incident-report/details/:id',
        name: "incidentReportDetails",
        component: loadComponent('UserIncidentsReport/Detail'),
        meta: {
            forUsers: true,
            permission: "read-incident-report",
            breadcrumbs: [
                {
                    text: 'User Incidents',
                    disabled: false,
                    href: '/incident-report'
                },
                {
                    text: "Incident Details",
                    disabled: true
                }
            ]
        }
    },
    //Itinerary
    {
        path: '/itinerary-list',
        name: "itineraries",
        component: loadComponent('Itinerary/Index'),
        meta: {
            forUsers: true,
            permission: "read-itineraries"
        }
    },
    //for upcoming trains which display according to station and platforms
    {
        path: '/upcomingPlatformTrains',
        name: "upcomingTrains",
        component: loadComponent('upcomingTrains'),
        meta: {
            forGuests: true
        }
    },
    //train wise rake tracking
    {
        path: "/train-wise-rake-tracking",
        name: "TrainWiseRakeTracking",
        component: loadComponent('TrainWiseRake/Index'),
        meta: {
            forUsers: true,
            permission: "read-train-tracking"
        }

    },
    {
        path: "/vip-subscriptions",
        name: 'VIPSubscriptionList',
        component: loadComponent('VIPSubscription/Index'),
        meta: {
            forUsers: true,
            permission: "read-vip-subscriptions"
        },
    },
    {
        path: "/ipl-matches",
        name: "IPLMatchesList",
        component: loadComponent('IPLMatch/Index'),
        meta: {
            forUsers: true,
            permission: "read-ipl-data"
        }
    },
    {
        path: '/ad-mob',
        name: 'adMobDashboard',
        component: loadComponent('AdMob/Index'),
        meta: {
            forUsers: true,
            permission: 'read-dashboard'
        }
    },
    {
        path: '/ads/schedules',
        name: 'adSchedules',
        component: loadComponent('AdMob/DynamicSchedule'),
        meta: {
            forUsers: true,
            permission: 'read-dashboard'
        }
    },
    {
        path: '/ondc-settlement',
        name: 'ondcSettlement',
        component: loadComponent('Settlement/Index'),
        meta: {
            forUsers: true,
            permission: 'read-settlement'
        }
    },
    {
        path: '/ondc-issue-grievance',
        name: 'ondcIssueGrievance',
        component: loadComponent('IGM/Index'),
        meta: {
            forUsers: true,
            permission: 'read-dashboard'
        }
    },
    // {
    //     path: '/ondc-issue-grievance',
    //     name: 'ondcIssueGrievance',
    //     component: loadComponent('IGM/Index'),
    //     meta: {
    //         forUsers: true,
    //         permission: 'read-dashboard'
    //     }
    // },
    {
        path: '/ondc-issue-grievance/:id',
        name: 'ondcIssueGrievanceDetails',
        component: loadComponent('IGM/Detail'),
        meta: {
            forUsers: true,
            permission: 'read-dashboard',
            breadcrumbs: [
                {
                    text: 'Issue',
                    disabled: false,
                    href: '/ondc-issue-grievance'
                },
                {
                    text: "Issue Details",
                    disabled: true
                }
            ]
        }
    },
    {
        path: '/coupon-code',
        name: 'Coupon Code',
        component: loadComponent('CouponCode/coupon-code'),
        meta: {
            forUsers: true,
            permission: 'import-data-master'
        }
    },
    {
        path: '/coupon-code-form',
        name: 'Coupon Code Form',
        component: loadComponent('CouponCode/coupon-code-form'),
        meta: {
            forUsers: true,
            permission: 'import-data-master'
        }
    },
    {
        path: '/coupon-code-list',
        name: 'Coupon Code List',
        component: loadComponent('CouponCode/coupon-code-list'),
        meta: {
            forUsers: true,
            permission: 'import-data-master'
        }
    },
    {
        path: '/yatri-campaign',
        name: 'Yatri Campaign',
        component: loadComponent('YatriCampaign/yatri-campaign'),
        meta: {
            forUsers: true,
            permission: 'import-data-master'
        }
    },
    {
        path: '/yatri-campaign-form',
        name: 'Yatri Campaign Form',
        component: loadComponent('Yatsrc/components/YatriCampaignriCampaign/yatri-campaign-form'),
        meta: {
            forUsers: true,
            permission: 'import-data-master'
        }
    },
    {
        path: '/yatri-campaign-list',
        name: 'Yatri Campaign List',
        component: loadComponent('YatriCampaign/yatri-campaign-list'),
        meta: {
            forUsers: true,
            permission: 'import-data-master'
        }
    },
    {
        path: '/winners',
        name: 'Winners',
        component: loadComponent('YatriCampaign/winners'),
        meta: {
            forUsers: true,
            permission: 'import-data-master'
        }
    },
    {
        path: '/yatri-festival',
        name: 'Yatri Festival',
        component: loadComponent('YatriFestival/yatri-festival'),
        meta: {
            forUsers: true,
            permission: 'import-data-master'
        }
    },
    {
        path: '/yatri-festival-form',
        name: 'Yatri Festival Form',
        component: loadComponent('YatriFestival/yatri-festival-form'),
        meta: {
            forUsers: true,
            permission: 'import-data-master'
        }
    },
    {
        path: '/yatri-festival-list',
        name: 'Yatri Festival List',
        component: loadComponent('YatriFestival/yatri-festival-list'),
        meta: {
            forUsers: true,
            permission: 'import-data-master'
        }
    },
    {
        path: '/yatri-refund',
        name: 'Refund',
        component: loadComponent('YatriRefund/yatri-refund'),
        meta: {
            forUsers: true,
            permission: 'import-data-master'
        }
    }
];

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
});

router.beforeEach((to, from, next) => {
    if (localStorage.getItem('access_token')) {
        if (to.name === 'login') {
            window.location.href = '/';
        } else {
            next();
        }
    } else if (localStorage.getItem('access_token') == null) {
        if (to.name !== 'login') {
            next({ name: 'login' });
        } else if (to.name === 'ondc-site-verification.html') {
            next();
        }
        next();
    } else {
        next();
    }

});

export default router;
